import infoIcon from '../assets/images/info-icon.svg';

export const LabelUI = ({ label, content }) => {

    return (
        <>
            <div
                style={{
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: "10px",
                }}
            >
                {/* Label badge */}
                <span
                    className="tooltip-trigger"
                    style={{
                        cursor: "default",
                        userSelect: "none",
                    }}
                >
                    {/*{label}*/}
                    <img src={infoIcon} height="22px" />
                </span>

                {/* Tooltip on hover */}
                <style>{`
                                    .tooltip-trigger:hover::after {
                                        content: "${content}";
                                        position: absolute;
                                        top: -50px;
                                        left: calc(10% + 8px);
                                        transform: translateY(-50%);
                                        background-color: #333;
                                        color: #fff;
                                        padding: 6px 10px;
                                        border-radius: 6px;
                                        font-size: 12px;
                                        white-space: normal;        /* ← wrap text instead of nowrap */
                                        word-wrap: break-word;      /* ← break long words */
                                        word-break: break-word;     /* ← extra safety for long strings */
                                        max-width: 420px;           /* ← limit tooltip width */
                                        width: max-content;
                                        z-index: 999;
                                        pointer-events: none;
                                        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                                        line-height: 1.4;           /* ← better readability for multiline */
                                    }
                                    .tooltip-trigger:hover::before {
                                        content: "";
                                        position: absolute;
                                        top: 50%;
                                        left: calc(100% + 2px);
                                        transform: translateY(-50%);
                                        border: 5px solid transparent;
                                        border-right-color: #333;
                                        z-index: 999;
                                    }
                                `}</style>
            </div>
        </>
    )
}

